import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService, Toast } from '../../core/services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-container">
      <div 
        *ngFor="let toast of toasts" 
        class="ora-toast"
        role="status" 
        aria-live="assertive"
        (click)="remove(toast.id)">
        <span class="ora-ico-badge" aria-hidden="true">
          <img class="ora-ico" src="assets/IconORA.svg" alt="">
        </span>
        <span class="ora-txt">
          <span class="ora-title">{{toast.message}}</span>
          <span class="ora-sub" *ngIf="toast.subtitle">{{toast.subtitle}}</span>
        </span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .toast-container {
      position: fixed;
      top: 0;
      right: 0;
      z-index: 10000;
      pointer-events: none;
    }

    .ora-toast {
      position: fixed;
      top: 16px;
      right: 24px;
      display: flex;
      align-items: flex-start;
      gap: 14px;
      padding: 14px 16px;
      background: #FFF4FA;
      border: 1px solid #F7A8D0;
      border-radius: 12px;
      box-shadow: 0 16px 44px rgba(255,42,160,.18), 0 10px 24px rgba(17,24,39,.06);
      max-width: min(520px, calc(100vw - 40px));
      z-index: 10000;
      transform: translate(12px,-22px) scale(.86) rotate(-2deg);
      opacity: 0;
      animation: toastEnterStrong .40s cubic-bezier(.2,1.1,.2,1) forwards, toastPopShadow .90s ease-out .25s forwards;
      cursor: pointer;
      pointer-events: auto;
    }

    .ora-toast::after {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: inherit;
      pointer-events: none;
      background: linear-gradient(120deg, transparent 40%, rgba(255,255,255,.6) 50%, transparent 60%);
      transform: translateX(-120%);
      animation: toastSheen 1.1s ease .22s forwards;
    }

    @keyframes toastEnterStrong {
      0% { opacity: 0; transform: translate(12px,-22px) scale(.86) rotate(-2deg); }
      60% { opacity: 1; transform: translate(0,0) scale(1.06); }
      100% { opacity: 1; transform: translate(0,0) scale(1); }
    }

    @keyframes toastPopShadow {
      0% { box-shadow: 0 16px 44px rgba(255,42,160,.18), 0 10px 24px rgba(17,24,39,.06); }
      50% { box-shadow: 0 28px 70px rgba(255,42,160,.24), 0 16px 34px rgba(17,24,39,.10); transform: scale(1.02); }
      100% { box-shadow: 0 16px 44px rgba(255,42,160,.18), 0 10px 24px rgba(17,24,39,.06); transform: scale(1); }
    }

    @keyframes toastSheen {
      to { transform: translateX(120%); }
    }

    .ora-ico-badge {
      width: 28px;
      height: 28px;
      border-radius: 999px;
      background: #fff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 28px;
      animation: headPopStrong .5s .1s cubic-bezier(.21,1,.26,1) both;
    }

    @keyframes headPopStrong {
      0% { transform: scale(.55); opacity: 0; }
      55% { transform: scale(1.22); opacity: 1; }
      100% { transform: scale(1); }
    }

    .ora-ico {
      width: 18px;
      height: 18px;
      display: block;
    }

    .ora-txt {
      display: flex;
      flex-direction: column;
      line-height: 1.25;
    }

    .ora-title {
      color: #FF1E8A;
      font-weight: 600;
      font-size: 18px;
      line-height: 1.2;
    }

    .ora-sub {
      margin-top: 6px;
      color: #111827;
      font-weight: 700;
      font-size: 15px;
      line-height: 1.3;
    }

    @media (max-width: 640px) {
      .ora-toast {
        right: 16px;
        left: 16px;
        max-width: none;
      }
    }
  `]
})
export class ToastComponent implements OnInit {
  toasts: Toast[] = [];

  constructor(private toastService: ToastService) {}

  ngOnInit() {
    this.toastService.toasts$.subscribe(toasts => {
      this.toasts = toasts;
    });
  }

  remove(id: string) {
    this.toastService.remove(id);
  }
}